// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"MzLcC"};